import React, { useEffect, useState, useContext, Fragment } from "react";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../../../context/AlertContext";
import constants from "../../../../../../constants";
import Loading from "../../../../../Notification-Loading/Loading/Loading";
import {
  getDataFromStorage,
  MANAGEMENTROLES,
  isClosingSoon,
} from "../../../../../../util";
import Badge from "../../../../../CommonComponents/Badge";
import moment from "moment";
import { Link } from "react-router-dom";
import Tooltip from "../../../../../CommonComponents/Tooltip";
import CircularProgress from '@mui/material/CircularProgress';
import { SOAJobsInternshipsSkeleton } from "./SOAJobsInternshipsSkeleton";

const SOAJobsInternships = () => {
  const Alert = useContext(AlertContext);

  const {
    isAdmin,
    expandedJob,
    setIsLoaded,
    initialJobs,
    setInitialJobs,
    filteredJobs,
    setExpandedJob,
    setFilteredJobs,
  } = useContext(AlertContext);

  const [error, setError] = useState(null);
  const [expValue, setExpValue] = useState([]);
  const [expRange, setExprange] = useState([0, 30]);
  const [jobTypes, setJobTypes] = useState([]);
  const [salryValue, setSalaryValue] = useState([0, 5000000]);
  const [selectedWorkModes, setSelectedWorkModes] = useState([]);
  const [selectedQualifications, setSelectedQualifications] = useState([]);

  const axios = useAxiosPrivate();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setIsLoaded(true);
        const searchParams = {
          role: "learner",
          roletype: jobTypes,
          minctc: salryValue[0],
          maxctc: salryValue[1],
          workmode: selectedWorkModes,
          minexp: expRange[0],
          maxexp: expRange[1],
        };

        if (expRange.length > 0) {
          searchParams.minexp = expRange[0];
        }

        if (expRange.length > 1) {
          searchParams.maxexp = expRange[1];
        }

        const queryString = new URLSearchParams(searchParams).toString();

        const response = await axios.get(`node/learner/job?${queryString}`, {
          headers: {
            "Content-type": "application/json",
          },
        });

        setInitialJobs(response.data.data);
        setFilteredJobs(response.data.data);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoaded(false);
      }
    };
    fetchJobs();
  }, [
    expRange,
    expValue,
    jobTypes,
    salryValue,
    selectedWorkModes,
    selectedQualifications,
  ]);

  // console.log("JOBS and Internships", initialJobs);

  if(!initialJobs?.length > 0){
    return(
      <SOAJobsInternshipsSkeleton/>
    )
  }

  return (
    <div className="SOAJobsInternships-Container">

        <>
          {" "}
          <div className="SOAJobsInternships-Header"> Jobs & Internships </div>
          {/* <div className='SOAJobsCount' key="count"> {initialJobs.length ?? 0} New Openings</div> */}
          <div className="SOAJobsInternships-Body">
            {initialJobs.length > 0 ? (
              initialJobs.map((data) => (
                <Link
                  to={data.link}
                  className="SOAJob-content-sec"
                  key={data.id}
                  target="_blank"
                >
                  <div className="SOAJob-content">
                    <Tooltip title={data.name} placement="bottom" maxChars="35">
                      <div className="SOAJob-Title"> {data.name} </div>
                    </Tooltip>
                    <div className="SOAJob-Company"> {data.company} </div>
                  </div>
                  <hr />
                </Link>
              ))
            ) : (
              <></>
            )}
          </div>
        </>
    </div>
  );
};

export default SOAJobsInternships;
